import {BaseService} from "../../../global/classes";
import { bffApi } from "../../../services/bff/bffApi";

export class ContractsServices extends BaseService {
  getUnsignedContracts = async () => {
    try {
      const response = await bffApi.get(`/api/struct/v1/contracts/unsigned/${this.selectedCompany?.merchantId}`)

      return response.data;
    }
    catch (error) {
      throw error;
    }
  }

  getContracts = async(ids: string[]) => {
    try {
      const response = await bffApi.get(`/api/flux/v1/contracts`, {
        params: { ids },
        paramsSerializer: (params) => {
          return params.ids.map((id: string) => `ids=${id}`).join('&');
        },
      })

      return response.data;
    }
    catch (error) {
      throw error;
    }
  }

  updateContractsStatus = async(contractId: string) => {
    try {
      const response = await bffApi.patch(`/api/struct/v1/contracts/contract`, {
        contractId: contractId,
          merchantId: this.selectedCompany?.merchantId
        })

      return response.data;
    }
    catch (error) {
      throw error;
    }
  }

  getSignedContracts = async(
    pageNumber: number = 1,
    pageSize: number = 20) => {
    try {
      const response = await bffApi.get(`/api/struct/v1/contracts/signed/${this.selectedCompany?.merchantId}`, {
        params: {
          pageNumber,
          pageSize
        },
      })

      return response.data;
    }
    catch (error) {
      throw error;
    }
  }

  getAllSignedContracts = async(
    merchantId?: string | null,
    pageNumber: number = 1,
    pageSize: number = 20) => {
    try {
      const baseUrl = `/api/struct/v1/contracts/signed/all`;
      const url = merchantId ? `${baseUrl}/${merchantId}` : baseUrl;

      const response = await bffApi.get(url, {
        params: {
          pageNumber,
          pageSize
        },
      });

      return response.data;
    }
    catch (error) {
      throw error;
    }
  }
}
